<template>
  <div>
    <div class="left">
      <el-card class="box-card " header="个人信息" style="width:100%">
        <div @click="migfas=true"
          style="background-color: #f2f2f2;overflow:hidden;text-align:center;margin: 20px auto;width: 100px; height: 100px;border-radius: 50%;">
          <el-image v-if="userInfo.photo_path" title="点击修改头像" style="width: 100px; height: 100px;border-radius: 50%;"
            :src="userInfo.photo_path" fit="cover"></el-image>
        </div>
        <div class="left-item"><i class="el-icon-s-custom"></i> 用户昵称<span class="left-span">{{ userInfo.name }}</span>
        </div>
        <div class="left-item"><i class="el-icon-mobile"></i> 手机号<span class="left-span">{{ userInfo.phone }}</span>
        </div>
        <div class="left-item"><i class="el-icon-edit"></i> 密码<span class="left-span">******</span></div>
        <div class="left-item"><i class="el-icon-female"></i> 性别<span class="left-span">
            <template v-if="userInfo.sex == 1">男</template>
            <template v-else-if="userInfo.sex == 2">女</template>
            <template v-else>未知</template>
          </span></div>
        <!-- <div class="left-item"><i class="el-icon-date"></i> 创建日期<span class="left-span">{{data.createTime}}</span></div> -->
      </el-card>
    </div>
    <div class="right">
      <el-card class="box-card" header="基本资料" style="width:100%">
        <el-tabs v-model="activeName">
          <el-tab-pane label="基本资料" name="基本资料">
            <el-form :model="dataForm" ref="dataForm" :rules="rules" class="demo-ruleForm" style="overflow:hidden">
              <el-form-item label="用户昵称" prop="name">
                <el-input placeholder="请输入昵称" v-model="dataForm.name" :maxlength='15' show-word-limit></el-input>
              </el-form-item>

              <el-form-item label="性别" prop="sex">
                <el-select v-model="dataForm.sex" placeholder="请选择" style="width:100%">
                  <el-option v-for="item in genderList" :key="item.value" :label="item.label" :value="item.value">
                  </el-option>
                </el-select>
              </el-form-item>
              <el-form-item>
                <el-button type="primary" size="small" @click="update(0)">保存</el-button>
                <el-button size="small" @click="reset()">重置</el-button>
              </el-form-item>
            </el-form>
          </el-tab-pane>
          <el-tab-pane label="修改密码" name="修改密码">
            <el-form :model="psdForm" ref="psdForm" :rules="psdrules" class="demo-ruleForm" style="overflow:hidden">
              <el-form-item label="旧密码" prop="old_pwd">
                <el-input placeholder="请输入旧密码" v-model="psdForm.old_pwd" :maxlength='16' show-password clearable>
                </el-input>
              </el-form-item>
              <el-form-item label="新密码" prop="new_pwd">
                <el-input placeholder="请输入新密码" v-model="psdForm.new_pwd" :maxlength='16' show-password clearable>
                </el-input>
              </el-form-item>
              <el-form-item label="确认密码" prop="new_pwd_confirmation">
                <el-input placeholder="请确认密码" v-model="psdForm.new_pwd_confirmation" :maxlength='16' show-password
                  clearable></el-input>
              </el-form-item>
              <el-form-item>
                <el-button type="primary" size="small" @click="uptpsd()">保存</el-button>
              </el-form-item>
            </el-form>
          </el-tab-pane>
          <el-tab-pane label="修改手机" name="修改手机">
            <el-form :model="erification" ref="erification" :rules="rules1" class="demo-ruleForm">

              <el-form-item label="手机号码" prop="user_phone">
                <el-input type='number' placeholder="请输入11位手机号" v-model="erification.user_phone"></el-input>
              </el-form-item>

              <el-form-item label="验证码" prop="phone_code">
                <div style="display: flex;align-items: center;">
                  <el-input type='number' style="width: 180px;" placeholder="请输入验证码" v-model="erification.phone_code">
                  </el-input>
                  <el-button type="primary" style="margin-left: 20px;" :disabled='disabled' @click="getCode">
                    {{ btnText }}</el-button>
                </div>
              </el-form-item>

              <el-form-item>
                <el-button type="primary" size="small" @click="resetPhone">保存</el-button>
                <!-- <el-button size="small" @click="reset()">重置</el-button> -->
              </el-form-item>
            </el-form>
          </el-tab-pane>
        </el-tabs>
      </el-card>
    </div>
    <avatar-cropper :dialogVisible.sync="migfas" @closeAvatarDialog="closeAvatarDialog"></avatar-cropper>
  </div>
</template>
<script>
  import avatarCropper from '@/components/avatarCropper'
  import userInfoAPI from '@/api/api';
  import { upload } from '@/api/upload';
  export default {
    components: {
      avatarCropper
    },
    data() {
      var self = this;
      const validatePassword = (rule, value, callback) => {
        if (value.length < 6) {
          callback(new Error('密码不能为空，且不少六位数'))
        } else {
          callback()
        }
      }
      const isPhone = (rule, value, callback) => {
        if (!/^1[23456789]\d{9}$/.test(value)) {
          callback(new Error('输入的手机号格式错误'))
        } else {
          callback()
        }
      }
      return {
        userInfo: '',
        imageUrl: 'https://fuss10.elemecdn.com/e/5d/4a731a90594a4af544c0c25941171jpeg.jpeg',
        userId: null,
        img: '',
        activeName: '基本资料',
        migfas: false,
        dataForm: {
          name: '',
          sex: '',
        },
        erification: {
          user_phone: '',
          phone_code: '',
        },
        psdForm: {
          old_pwd: '',
          new_pwd: '',
          new_pwd_confirmation: ''
        },
        genderList: [{
            value: 1,
            label: '男'
          },
          {
            value: 2,
            label: '女'
          }
        ],
        disabled: false,
        rules: {
          name: [{
            required: true,
            message: '请输入用户昵称',
            trigger: 'blur'
          }],
          sex: [{
            required: true,
            message: '请选择性别',
            trigger: 'blur'
          }]
        },
        rules1: {
          user_phone: [{
              required: true,
              message: '请输入11位手机号',
              trigger: 'blur'
            },
            {
              validator: isPhone,
              trigger: 'blur'
            }
          ],
          phone_code: [{
            required: true,
            message: '请输入验证码',
            trigger: 'blur'
          }]
        },
        psdrules: {
          old_pwd: [{
            required: true,
            message: '请输入旧密码',
            trigger: 'blur'
          }],
          new_pwd: [{
              required: true,
              message: '请输入新密码',
              trigger: 'blur'
            },
            {
              required: true,
              trigger: 'blur',
              validator: validatePassword
            }

          ],
          new_pwd_confirmation: [{
              required: true,
              message: '请输入新密码',
              trigger: 'blur'
            },
            {
              validator: self.verifypsd,
              trigger: 'blur'
            }
          ],
        },
        fastClick: true,
        btnText: '获取验证码',
        timer: null
      }
    },
    created() {
      this.getUserInfo()
    },

    methods: {
      getCode() {
        var that = this;
        if (!this.erification.user_phone) {
          this.$message({
            message: "请输入手机号",
            type: 'error'
          });
          return
        }
        if (!/^1[23456789][\d]{9}$/.test(this.erification.user_phone)) {
          this.$message({
            message: "手机号格式有误",
            type: 'error'
          });
          return
        }
        if (this.disabled) return
        this.disabled = true
        userInfoAPI.getPhoneCode({
          user_phone: this.erification.user_phone,
          scene_name: 'changePhone'
        }).then(res => {
          if (res.data.code == 0) {
            let countdown = 60
            that.btnText = '重新获取(' + countdown + 's)'
            that.timer = setInterval(() => {
              if (countdown > 0) {
                countdown--
                countdown = countdown < 10 ? '0' + countdown : countdown
                that.btnText = '重新获取(' + countdown + 's)'
              } else {
                clearInterval(that.timer)
                that.disabled = false
                that.btnText = '获取验证码'
              }
            }, 1000)
            this.$message({
              message: "验证码发送成功，请注意查收！",
              type: 'success'
            });
          } else {
            // this.$message({
            //     message: res.data.msg,
            //     type: 'error'
            // });					   
          }
        }).catch(() => {
          that.disabled = false
        })
      },
      closeAvatarDialog(data) {
        upload([data], 'avatar').then((urls)=>{
          this.userInfo.photo_path = urls[0]
          this.update(1)
          this.migfas = false;
        }).catch(()=>{
          this.$message({
            message: '上传失败，请重新上传',
            type: 'error'
          }) 
        })
        
        
        // let formData = new FormData();
        // formData.append('file', data, "DX.jpg")
        // userInfoAPI.upload(formData).then(res => {
        //   if (res.data.code == 0) {
        //     this.userInfo.photo_path = res.data.data.file_storage_path
        //     this.update(1)
        //     this.migfas = false;
        //   } else {
        //     this.$message({
        //       message: res.data.msg,
        //       type: 'error'
        //     })
        //   }
        // })
      },
      /**
       * 获取用户详细信息
       * @method details
       */
      getUserInfo() {
        userInfoAPI.getUserInfo().then(res => {
          this.userInfo = res.data.data
          this.$store.dispatch('setAvatar', res.data.data.photo_path)
          this.$store.commit('SET_NAME', res.data.data.name)
          this.dataForm.name = res.data.data.name
          this.erification.user_phone = res.data.data.phone
          this.dataForm.sex = res.data.data.sex
        })
      },
      /**
       * 重置用户基本信息
       * @method reset
       */
      reset() {
        this.dataForm.name = ""
        this.dataForm.sex = null
      },
      resetPhone() {
        this.$refs.erification.validate((valid) => {
          if (valid) {
            userInfoAPI.userResetPhone(this.erification, this.userInfo.uid).then(res => {
              if (res.data.code == 0) {
                this.getUserInfo()
                this.$message({
                  message: res.data.msg,
                  type: 'success'
                });
              } else {
                this.$message({
                  message: res.data.msg,
                  type: 'error'
                })
              }
            })
          }
        })

      },
      /**
       * 修改用户基本信息
       * @method update
       */
      update(type) {
        var vm = this;
        this.$refs.dataForm.validate((valid) => {
          if (valid) {
            userInfoAPI.systemUser3({
              name: type == 1 ? this.userInfo.name : this.dataForm.name,
              sex: type == 1 ? this.userInfo.sex : this.dataForm.sex,
              phone: this.userInfo.phone,
              role_id: this.userInfo.role_id,
              area_id: this.userInfo.area_id,
              photo_path: this.userInfo.photo_path
            }, this.userInfo.uid).then(res => {
              if (res.data.code == 0) {
                this.getUserInfo()
                this.$message({
                  message: res.data.msg,
                  type: 'success'
                });
              } else {
                this.$message({
                  message: res.data.msg,
                  type: 'error'
                })
              }

            })
          }
        })
      },
      /**
       * 验证两次输入的新密码相不相同
       * @method verifypsd
       */
      verifypsd(rule, value, callback) {
        if (this.psdForm.new_pwd === this.psdForm.new_pwd_confirmation) {
          return callback()
        } else {
          return callback(new Error('两次密码不一致'))
        }
      },
      /**
       * 修改密码
       * @method uptpsd
       */
      uptpsd() {
        this.$refs.psdForm.validate((valid) => {
          if (valid) {
            userInfoAPI.userUpdatePwd(this.psdForm).then(res => {
              console.log(res)
              if (res.data.code == 0) {
                this.logout()
                this.$message({
                  message: "修改成功，请重新登录",
                  type: 'success'
                });
              } else {
                this.$message({
                  message: res.data.msg,
                  type: 'error'
                });
              }
            })
          } else {
            console.log('error submit!!');
            return false;
          }
        })
      },
      logout() {
        this.$store.dispatch('LogOut').then(() => {
          location.reload() // In order to re-instantiate the vue-router object to avoid bugs
        })
      }
    }
  }
</script>
<style scoped>
  .avatar-uploader .el-upload {
    border: 1px dashed #d9d9d9;
    /* border: 1px solid red; */
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
  }

  .avatar-uploader .el-upload:hover {
    border-color: #409EFF;
  }

  .avatar-uploader-icon {
    border: 1px dashed #d9d9d9;
    font-size: 28px;
    color: #8c939d;
    width: 150px;
    height: 150px;
    line-height: 150px;
    text-align: center;
    border-radius: 50%;
  }

  /* .avatar-uploader-icon.el-upload:hover{
      border-color: #409EFF;
  } */
  .avatar {
    width: 178px;
    height: 178px;
    display: block;
  }
</style>
<style scoped>
  .left {
    float: left;
    width: 40%;
    padding: 20px;
  }

  .left-item {
    height: 40px;
    line-height: 40px;
    font-size: 16px;
    border-bottom: 1px solid #EBEEF5;
    margin-bottom: 20px;
  }

  .left-span {
    float: right;
  }

  .right {
    float: left;
    width: 60%;
    padding: 20px 20px 20px 0;
  }

  .img {
    width: 100px;
    height: 100px;
    display: block;
    margin: 10px auto 20px;
  }
</style>
